import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ab2a3226"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_view_export_dropdown = _resolveComponent("view-export-dropdown");
  const _component_bar_line_chart_icon = _resolveComponent("bar-line-chart-icon");
  const _component_wrap_with_highlight = _resolveComponent("wrap-with-highlight");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_table_skeleton_v2 = _resolveComponent("table-skeleton-v2");
  const _component_flex_column = _resolveComponent("flex-column");
  return _openBlock(), _createBlock(_component_flex_column, {
    gap: $props.gap,
    class: "table-with-title"
  }, {
    default: _withCtx(() => [_createVNode(_component_flex_row, {
      style: _normalizeStyle({
        justifyContent: 'flex-start',
        ...$props.customStyles
      }),
      gap: 16
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString($props.title), 1), !$props.noDownload ? (_openBlock(), _createBlock(_component_view_export_dropdown, {
        key: 0,
        onCsvDownload: _cache[0] || (_cache[0] = $event => _ctx.$emit('download')),
        onCsvCopy: _cache[1] || (_cache[1] = $event => _ctx.$emit('copy')),
        onGoogleSheetDownload: _cache[2] || (_cache[2] = $event => _ctx.$emit('google-sheet-download')),
        placement: "right"
      })) : _createCommentVNode("", true), _ctx.$slots['chart-modal'] ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
        key: 1,
        width: "fit-content"
      }, {
        title: _withCtx(() => [_createTextVNode(" Metric Evolution ")]),
        default: _withCtx(() => [_createVNode(_component_wrap_with_highlight, {
          onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('chart-modal-open')),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_bar_line_chart_icon)]),
          _: 1
        }, 8, ["loading"])]),
        _: 1
      })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "period-selector", {}, undefined, true)]),
      _: 3
    }, 8, ["style"]), $props.loading ? (_openBlock(), _createBlock(_component_table_skeleton_v2, {
      key: 0,
      fields: $props.fields
    }, null, 8, ["fields"])) : _renderSlot(_ctx.$slots, "default", {
      key: 1
    }, undefined, true), _renderSlot(_ctx.$slots, "chart-modal", {}, undefined, true)]),
    _: 3
  }, 8, ["gap"]);
}